import { Drawer as AntdDrawer, DrawerProps } from 'antd';
import { FC, ReactNode, memo } from 'react';
import { XCircleFill } from 'react-bootstrap-icons';

import './AppDrawer.scss';

interface Props extends DrawerProps {
  children: ReactNode;
  isDisabled?: boolean;
}

export const AppDrawer: FC<Props> = memo(({ children, isDisabled, ...otherProps }) => {
  return (
    <AntdDrawer
      className={ `app-drawer ${ otherProps.className ?? '' }` }
      closeIcon={ <XCircleFill size={ 20 }/> }
      closable={ isDisabled ? !isDisabled : isDisabled }
      destroyOnClose
      { ...otherProps }
    >
      { children }
    </AntdDrawer>
  );
});
